import { render, staticRenderFns } from "./detailsOrder.vue?vue&type=template&id=08143f88&"
import script from "./detailsOrder.vue?vue&type=script&lang=js&"
export * from "./detailsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports